/**
 * Generate a filename with optional prefixes from file fields (clasa, liceu)
 * @param file - File object with name and fields array
 * @returns Generated filename with .pdf extension
 */

interface Field {
  type: string;
  name: string;
  value?: any;
}

interface FileWithFields {
  name: string;
  fields?: Field[];
}

export const generateFilenameWithPrefixes = (file: FileWithFields): string => {
  // Search for a field of type 'text' with name 'clasa'
  const clasaField = file.fields?.find(
    (field) =>
      field.type === 'text' &&
      field.name === 'clasa' &&
      field.value !== null &&
      field.value !== undefined &&
      field.value !== ''
  );

  // Search for a field of type 'multi-level-combobox' with name 'liceu'
  const liceuField = file.fields?.find(
    (field) =>
      field.type === 'multi-level-combobox' &&
      field.name === 'liceu' &&
      field.value !== null &&
      field.value !== undefined &&
      field.value.liceu !== null &&
      field.value.liceu !== undefined &&
      field.value.liceu !== ''
  );

  // Sanitize filename: lowercase, replace spaces with underscores, keep alphanumeric, underscores, and diacritics
  const sanitizeFilename = (str: string): string => {
    return str
      .toLowerCase()
      .replace(/\s+/g, '_')
      .replace(/[^\p{L}\p{N}_]/gu, '');
  };

  // Build filename prefix from clasa and liceu fields if they have values
  const prefixes: string[] = [];
  if (clasaField) {
    prefixes.push(sanitizeFilename(String(clasaField.value)));
  }
  if (liceuField) {
    prefixes.push(sanitizeFilename(String(liceuField.value.liceu)));
  }

  // Sanitize file name
  const sanitizedFileName = sanitizeFilename(file.name);

  // If prefixes exist, join them with underscore and add to filename
  const fileName =
    prefixes.length > 0
      ? `${prefixes.join('_')}_${sanitizedFileName}.pdf`
      : `${sanitizedFileName}.pdf`;

  return fileName;
};
